import { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Tarkista onko evästeet jo hyväksytty tai hylätty
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    // Lataa sivu uudelleen jotta Google Analytics käynnistyy
    window.location.reload();
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.banner}>
        <div style={styles.content}>
          <h3 style={styles.title}>🍪 Evästeet</h3>
          <p style={styles.text}>
            Käytämme evästeitä parantaaksemme käyttökokemustasi ja analysoidaksemme 
            sivuston liikennettä. Hyväksymällä evästeet autat meitä kehittämään palveluamme.
          </p>
          <div style={styles.buttonContainer}>
            <button className="cookie-accept-btn" style={styles.acceptButton} onClick={handleAccept}>
              Hyväksy evästeet
            </button>
            <button className="cookie-reject-btn" style={styles.rejectButton} onClick={handleReject}>
              Hylkää
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    padding: '0 20px 20px 20px',
    pointerEvents: 'none',
  },
  banner: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.15)',
    maxWidth: '600px',
    margin: '0 auto',
    pointerEvents: 'auto',
    animation: 'slideUp 0.4s ease-out',
  },
  content: {
    padding: '24px',
  },
  title: {
    margin: '0 0 12px 0',
    fontSize: '20px',
    fontWeight: '600',
    color: '#1a1a1a',
  },
  text: {
    margin: '0 0 20px 0',
    fontSize: '14px',
    lineHeight: '1.6',
    color: '#4a4a4a',
  },
  buttonContainer: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  acceptButton: {
    flex: '1',
    minWidth: '140px',
    padding: '12px 24px',
    backgroundColor: '#4CAF50',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 8px rgba(76, 175, 80, 0.3)',
  },
  rejectButton: {
    flex: '1',
    minWidth: '140px',
    padding: '12px 24px',
    backgroundColor: '#f5f5f5',
    color: '#4a4a4a',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
};

// Lisää CSS animaatio
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes slideUp {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  /* Vain evästebannerin nappien efektit */
  .cookie-accept-btn:hover,
  .cookie-reject-btn:hover {
    transform: translateY(-2px);
  }
  
  .cookie-accept-btn:active,
  .cookie-reject-btn:active {
    transform: translateY(0);
  }
  
  .cookie-accept-btn:hover {
    background-color: #45a049 !important;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4) !important;
  }
  
  .cookie-reject-btn:hover {
    background-color: #e8e8e8 !important;
    border-color: #ccc !important;
  }
  
  @media (max-width: 768px) {
    /* Mobiilityyli */
  }
`;
document.head.appendChild(styleSheet);

export default CookieBanner;